import EmojiAvatar from '@components/EmojiAvatar';
import { StyleBreakpoints, resourceEmoji } from '@constants';
import { Button, TextField } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { ArrowBack as ArrowBackIcon } from '@material-ui/icons';
import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import messages from './messages';

const useStyles = makeStyles(theme => ({
  textField: {
    marginBottom: '24px'
  },
  createButton: {
    width: '100%',

    [theme.breakpoints.up(StyleBreakpoints.sm)]: {
      width: 'auto'
    }
  },
  backBtn: {
    fontSize: '13px',
    color: '#000',
    padding: 0,
    marginBottom: '6px'
  },
  backButton: {
    marginTop: '12px',
    color: '#c2c2c2'
  }
}));

const CreateOrEditTipDirectResource = ({
  submitCreateResource,
  closeCreateResource,
  existingResource,
  editResource
}) => {
  const intl = useIntl();
  const classes = useStyles();

  const [name, setName] = useState(existingResource?.name || '');
  const [description, setDescription] = useState(existingResource?.description || '');
  const [selectedEmoji, setSelectedEmoji] = useState(existingResource?.emoji || ':credit_card:');
  const isCreateButtonDisabled = name.trim() === '';
  const isEditButtonDisabled =
    name === existingResource?.name &&
    description === existingResource?.description &&
    selectedEmoji === existingResource?.emoji;

  const handleCreateResourceClicked = () => {
    if (!name) return;

    if (existingResource) {
      editResource({ id: existingResource._id, name, description, emoji: selectedEmoji });
      return;
    }

    submitCreateResource(name, description, selectedEmoji);
  };
  const handleTitleUpdate = e => {
    setName(e.target.value);
  };

  const handleDescriptionUpdate = e => {
    setDescription(e.target.value);
  };

  const handleBackClick = () => {
    closeCreateResource();
  };

  return (
    <div className="flex flex-col justify-center flex-1 sm:max-w-[400px] sm:justify-start">
      <div>
        <Button
          className={`${classes.backBtn} !normal-case !text-slate-500 !font-semibold`}
          onClick={handleBackClick}
          color="primary"
          startIcon={<ArrowBackIcon />}>
          {intl.formatMessage(messages.resources)}
        </Button>
        <div className="text-xl font-bold text-slate-800 tracking-tight mb-0.5">
          {intl.formatMessage(existingResource ? messages.editTitle : messages.title)}
        </div>
        <div className="text-[13px] text-slate-500 mb-6">
          {intl.formatMessage(existingResource ? messages.editSubTitle : messages.subTitle)}
        </div>

        {existingResource ? (
          <div className="text-xl font-semibold text-slate-800 mb-3.5">
            {intl.formatMessage(messages.resourceIcon)}
          </div>
        ) : (
          <div className="text-[13px] text-slate-500 mb-6">{intl.formatMessage(messages.emojiTitle)}</div>
        )}
        <div className="flex flex-row flex-wrap justify-center max-w-full sm:max-w-[400px]">
          {resourceEmoji.map(emo => {
            return (
              <div className="mr-4 mb-4 h-[60px] w-[60px]" key={emo}>
                <EmojiAvatar
                  isClickable
                  code={emo}
                  selected={emo === selectedEmoji}
                  onClick={() => {
                    setSelectedEmoji(emo);
                  }}
                />
              </div>
            );
          })}
        </div>
        <TextField
          inputProps={{
            maxLength: 40
          }}
          fullWidth
          variant="outlined"
          color="primary"
          value={name}
          classes={{
            root: classes.textField
          }}
          InputLabelProps={{
            shrink: true
          }}
          type="string"
          onChange={handleTitleUpdate}
          label={intl.formatMessage(messages.nameLabel)}
          required
        />
        <TextField
          inputProps={{
            maxLength: 150
          }}
          multiline
          rows={4}
          fullWidth
          variant="outlined"
          color="primary"
          classes={{
            root: classes.textField
          }}
          InputLabelProps={{
            shrink: true
          }}
          type="string"
          value={description}
          onChange={handleDescriptionUpdate}
          label={intl.formatMessage(messages.descriptionLabel)}
        />
      </div>

      <div className="flex flex-col justify-center sm:justify-end">
        <Button
          className={`${classes.createButton} !bg-indigo-600 hover:!bg-indigo-700 !text-white !font-semibold !px-5 !py-2.5 !rounded-xl !shadow-sm !normal-case disabled:!bg-slate-300 disabled:!text-white`}
          variant="contained"
          color="primary"
          disabled={existingResource ? isEditButtonDisabled : isCreateButtonDisabled}
          onClick={handleCreateResourceClicked}>
          {existingResource
            ? intl.formatMessage(messages.saveChanges)
            : intl.formatMessage(messages.createResource)}
        </Button>
        {existingResource && (
          <Button
            className={`${classes.backButton} !normal-case !text-slate-500 !font-semibold`}
            color="secondary"
            onClick={closeCreateResource}>
            {intl.formatMessage(messages.back)}
          </Button>
        )}
      </div>
    </div>
  );
};

export default CreateOrEditTipDirectResource;
